import { useTrackMutation } from '@mote/api'
import { TickIcon } from '@mote/assets/icons'
import { CLIPBOARD_ANIMATION_TIMEOUT } from '@mote/helpers/constants'
import { Button } from '@mote/ui'
import copy from 'copy-to-clipboard'
import React from 'react'
import styled from 'styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

export const MoteCardRichCopyFullTranscriptText = ({ transcript }) => {
  const { playerDimensions } = useMotePlayer()
  const { mutate: track } = useTrackMutation()
  const [copiedToClipboard, setCopiedToClipboard] = React.useState(false)
  const copyTimeoutRef = React.useRef(null)

  async function handleCopyToClipboard() {
    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current)
      if (copiedToClipboard) setCopiedToClipboard(false)
    }

    try {
      await navigator.clipboard.writeText(transcript)
    } catch {
      copy(transcript)
    }

    track({ variables: { event: 'Transcript Copied To Clipboard' } })
    setCopiedToClipboard(true)

    copyTimeoutRef.current = setTimeout(
      () => setCopiedToClipboard(false),
      CLIPBOARD_ANIMATION_TIMEOUT
    )
  }

  React.useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current)
      }
    }
  }, [])

  return (
    <CopyButton
      variant='soft'
      icon={copiedToClipboard ? <TickIcon color='#ffffff' /> : null}
      text={copiedToClipboard ? 'Copied!' : 'Copy text'}
      onClick={handleCopyToClipboard}
      fontSize={moteCardFluidDimensionsAdjuster(
        12,
        12,
        playerDimensions?.width
      )}
      style={{
        padding: moteCardFluidDimensionsAdjuster(8, 4, playerDimensions?.width)
      }}
      autoWidth
    />
  )
}

const CopyButton = styled(Button)`
  height: auto;

  span {
    font-size: ${({ fontSize }) => fontSize}px;
    color: #ffffff;
  }

  span.button-icon {
    width: 1.2em;
    height: 1.2em;
    margin-right: 4px;
    margin-left: -3px;
  }

  background: rgba(33, 34, 40, 0.2);

  &:hover {
    background: rgba(33, 34, 40, 0.3);
  }

  &:active {
    background: rgba(33, 34, 40, 0.4);
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(47, 166, 255, 0.6);
  }
`
